(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root=document.querySelector('[data-lpc]');
  if(!root || root.dataset.ready==='1') return;
  root.dataset.ready='1';
  const buttons=[...root.querySelectorAll('[data-filter]')];
  const cards=[...root.querySelectorAll('[data-level]')];
  buttons.forEach(btn=>btn.addEventListener('click',()=>{
    const level=btn.dataset.filter;
    buttons.forEach(b=>b.classList.toggle('is-active',b===btn));
    cards.forEach(card=>card.classList.toggle('is-hidden',level!=='all' && card.dataset.level!==level));
  }));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root=document.querySelector('[data-lphd]');
  if(!root || root.dataset.ready==='1') return;
  root.dataset.ready='1';

  const shopBtn=root.querySelector('[data-lphd-shop]');
  const mega=root.querySelector('[data-lphd-mega]');
  let closeTimer;

  const openMega=()=>{ if(!shopBtn||!mega)return; clearTimeout(closeTimer); mega.classList.add('is-open'); shopBtn.setAttribute('aria-expanded','true'); };
  const closeMega=()=>{ if(!shopBtn||!mega)return; mega.classList.remove('is-open'); shopBtn.setAttribute('aria-expanded','false'); };
  const delayClose=()=>{ closeTimer=setTimeout(closeMega,140); };

  shopBtn?.addEventListener('mouseenter',openMega);
  shopBtn?.addEventListener('focus',openMega);
  shopBtn?.addEventListener('click',()=>{ closeMega(); });
  mega?.addEventListener('mouseenter',()=>clearTimeout(closeTimer));
  mega?.addEventListener('mouseleave',delayClose);
  shopBtn?.parentElement?.addEventListener('mouseleave',delayClose);
  document.addEventListener('click',e=>{ if(!root.contains(e.target)) closeMega(); });
  document.addEventListener('keydown',e=>{ if(e.key==='Escape') closeMega(); });

  const mobile=root.querySelector('[data-lphd-mobile]');
  const toggle=root.querySelector('[data-lphd-mobile-toggle]');
  const close=root.querySelector('[data-lphd-mobile-close]');
  const openMobile=()=>{mobile?.classList.add('is-open');toggle?.setAttribute('aria-expanded','true');document.documentElement.style.overflow='hidden';};
  const closeMobile=()=>{mobile?.classList.remove('is-open');toggle?.setAttribute('aria-expanded','false');document.documentElement.style.overflow='';};
  toggle?.addEventListener('click',openMobile);
  close?.addEventListener('click',closeMobile);
  mobile?.querySelectorAll('a').forEach(a=>a.addEventListener('click',closeMobile));

  const regionTrigger=root.querySelector('[data-lphd-region-trigger]');
  const regionMenu=root.querySelector('[data-lphd-region-menu]');
  const desktopCountry=root.querySelector('#LPHeaderCountry');
  const closeRegion=()=>{ regionMenu?.classList.remove('is-open'); regionTrigger?.setAttribute('aria-expanded','false'); };
  regionTrigger?.addEventListener('click',e=>{
    e.stopPropagation();
    const willOpen=!regionMenu?.classList.contains('is-open');
    closeRegion();
    if(willOpen){ regionMenu?.classList.add('is-open'); regionTrigger?.setAttribute('aria-expanded','true'); }
  });
  regionMenu?.querySelectorAll('[data-country-code]').forEach(btn=>{
    btn.addEventListener('click',()=>{
      if(!desktopCountry) return;
      desktopCountry.value=btn.dataset.countryCode;
      closeRegion();
      desktopCountry.form?.submit();
    });
  });
  document.addEventListener('click',e=>{
    if(regionMenu && !regionMenu.contains(e.target) && !regionTrigger?.contains(e.target)) closeRegion();
  });
  document.addEventListener('keydown',e=>{ if(e.key==='Escape') closeRegion(); });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-homepage"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-lph-carousel]');
  if (!root || root.dataset.ready === '1') return;
  root.dataset.ready = '1';
  const slides = [...root.querySelectorAll('[data-slide]')];
  const tabs = [...root.querySelectorAll('[data-go]')];
  let index = 0;
  let timer;
  let startX = null;

  const show = (next, manual = false) => {
    index = (next + slides.length) % slides.length;
    slides.forEach((s,i) => s.classList.toggle('is-active', i === index));
    tabs.forEach((t,i) => t.classList.toggle('is-active', i === index));
    if (manual) stop();
  };
  const stop = () => { if (timer) clearInterval(timer); timer = null; };
  const play = () => { stop(); timer = setInterval(() => show(index + 1), 5500); };

  tabs.forEach((t,i) => t.addEventListener('click', () => show(i, true)));
  root.querySelector('[data-prev]')?.addEventListener('click', () => show(index - 1, true));
  root.querySelector('[data-next]')?.addEventListener('click', () => show(index + 1, true));
  root.addEventListener('touchstart', e => { startX = e.touches?.[0]?.clientX ?? null; }, {passive:true});
  root.addEventListener('touchend', e => {
    if (startX == null) return;
    const endX = e.changedTouches?.[0]?.clientX ?? startX;
    if (Math.abs(endX - startX) > 50) show(index + (endX < startX ? 1 : -1), true);
    startX = null;
  }, {passive:true});
  play();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-shop-all"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root=document.querySelector('[data-lpshop]');
  if(!root || root.dataset.ready==='1') return;
  root.dataset.ready='1';
  const buttons=[...root.querySelectorAll('[data-lpshop-filter]')];
  const cards=[...root.querySelectorAll('[data-level]')];
  buttons.forEach(btn=>btn.addEventListener('click',()=>{
    const level=btn.dataset.lpshopFilter;
    buttons.forEach(b=>b.classList.toggle('is-active',b===btn));
    cards.forEach(card=>{ card.hidden = level!=='all' && card.dataset.level!==level; });
  }));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
